export function whenDomElementLoaded(domElementId, callback, callCount) {
    let domElement = document.getElementById(domElementId);

    if (domElement) {
        callback();
    } else {
        callCount++;
        if (callCount < 1000)
            setTimeout(() => {
                whenDomElementLoaded(domElementId, callback, callCount);
            }, 15);
    }
}

export function whenDomQueryLoaded(queryselector, callback, callCount) {
    let domElement = document.querySelector(queryselector);

    console.log('inside function');
    console.log('domElement', domElement);

    if (domElement) {
        callback();
    } else {
        callCount++;
        if (callCount < 1000)
            setTimeout(() => {
                whenDomQueryLoaded(queryselector, callback, callCount);
            }, 15);
    }
}
